package com.xtream.composeapp.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import theme.flavorDarkColorScheme
import theme.flavorLightColorScheme


enum class AppTheme {
    LIGHT,
    DARK,
    SYSTEM
}





@Composable
fun usesDarkMode(theme: AppTheme): Boolean {
    val isSystemInDarkTheme = isSystemInDarkTheme()
   return remember(theme) {
        if (theme == AppTheme.SYSTEM) isSystemInDarkTheme else if (theme == AppTheme.DARK) true else false
    } //else is LIGHT

}

@Composable
fun ComposeUITheme(
    theme: AppTheme= AppTheme.DARK,
// Dynamic color is available on Android 12+
    //dynamicColor: Boolean = true,
    content: @Composable () -> Unit
) {

    val darkTheme: Boolean = usesDarkMode(theme)

    //val context = LocalContext.current

    val colorScheme = remember(darkTheme) {
        if (darkTheme) flavorDarkColorScheme else flavorLightColorScheme
    }

    /*when {
        dynamicColor && Build.VERSION.SDK_INT >= Build.VERSION_CODES.S -> {

            if (darkTheme) dynamicDarkColorScheme(context) else dynamicLightColorScheme(context)
        }

        darkTheme -> DarkColorScheme
        else -> dynamicDarkColorScheme(context)
    }*/

    MaterialTheme(
        colorScheme = colorScheme,
        typography = getTypography(),
        content = content
    )
}

